import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

import { UsersService } from '../services/users.service';

export const platformAuthInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add headers for Platform API requests
  if (environment.platformServiceUrl === '' || !req.url.includes(environment.platformServiceUrl)) {
    return next(req);
  }

  const usersService = inject(UsersService);

  // Get token with error handling BEFORE making the request
  return usersService.getCurrentJWTToken().pipe(
    catchError(() => {
      return throwError(
        () =>
          new HttpErrorResponse({
            error: 'Authentication token unavailable',
            status: 401,
            statusText: 'Unauthorized',
            url: req.url,
          })
      );
    }),
    switchMap((token) => {
      let headers = req.headers;

      // Add Bearer token if available
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }

      const authReq = req.clone({ headers });
      return next(authReq);
    })
  );
};
